import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import {
  IS_REQUIRED,
  IS_VALID,
  isStringLengthGreaterThan,
  isStringLengthUpTo,
} from '@occc-app/lib/constants/validationMessages';
import { PHONE_NUMBER_REQUIRED_MESSAGE } from '@occc-app/routes/Member/MemberDetailsPage/components/EditModal/validation';
import { validatePhoneNumber } from '@occc/utils-phone-number';

export const upsertAllowListPhoneNumberValidationSchema = object({
  phoneNumber: string({ message: PHONE_NUMBER_REQUIRED_MESSAGE }).refine(
    validatePhoneNumber,
    IS_VALID,
  ),
  name: string({ message: IS_REQUIRED })
    .min(1, isStringLengthGreaterThan(1))
    .max(200, isStringLengthUpTo(200)),
  reason: string({ message: IS_REQUIRED })
    .min(1, isStringLengthGreaterThan(1))
    .max(2000, isStringLengthUpTo(2000)),
});

export const UpsertAllowListPhoneNumberValidation = makeValidate(
  upsertAllowListPhoneNumberValidationSchema,
);
